import React from "react";
import { Image, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";
import ProjectsLatestArticles from "./projects_latestarticles";

// local images
import image_main_thermalstorage from "../assets/images_homepage/thermalstorage_drawing.png";

const ProjectThermalStorage = () => (
  <>
    <Section
      id="thermal-storage"
      padding="60px 0 60px 0"
      md-padding="30px 0 30px 0"
      quarkly-title="Section_PP_Content"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-min-width="64px"
        padding="0px 0px 0px 0px"
        md-padding="0px 0px 0px 0px"
        md-width="100%"
        width="50%"
        lg-padding="0px 28px 0px 0px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
      >
        <Text
          font="--headline2"
          lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          margin="0px 0px 12px 0px"
          color="--green"
        >
          Thermal Storage
        </Text>
        <Text
          color="--light"
          font="--base"
          text-align="left"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
          md-margin="0px 0px 16px 0px"
          margin="0px 0px 0px 0px"
        >
          Exploring new frontiers: the PCM thermal battery!
          <br />
          Designed for placement in our solar greenhouse, this system seeks to
          absorb the intense heat load our greenhouse experiences in peak summer
          (like 50'C), then release it at cooler periods (like night).
          <br />
          <br />
          This project actively experiences: PCM chemical testing (with the PCM
          medium and property-changing-'dopant'), sensor data capture and
          monitoring, and manufacturing/assembly.{"\n\n"}
        </Text>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="50%"
        md-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
      >
        <Image
          src={image_main_thermalstorage}
          width="100%"
          max-height="350px"
          object-fit="cover"
          lg-min-height="300px"
          md-max-height="277px"
          md-min-height="16px"
          height="100%"
          overflow="hidden"
          srcSet={`${image_main_thermalstorage} 500w, ${image_main_thermalstorage} 800w, ${image_main_thermalstorage} 1080w, ${image_main_thermalstorage} 1600w, ${image_main_thermalstorage} 2000w, ${image_main_thermalstorage} 2600w, ${image_main_thermalstorage} 3200w`}
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        />
      </Box>
    </Section>
    <Section
      padding="60px 0 60px 0"
      md-padding="30px 0 30px 0"
      quarkly-title="Section_PP_Content2"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-min-width="64px"
        padding="0px 0px 0px 0px"
        md-padding="0px 0px 0px 0px"
        md-width="100%"
        width="50%"
        lg-padding="0px 28px 0px 0px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        margin="0px 0px 0px 0px"
      >
        <Text
          font="--headline2"
          lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          margin="0px 0px 12px 0px"
          color="--green"
        >
          Extra Info
        </Text>
        <Text
          color="--light"
          font="--base"
          text-align="left"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
          md-margin="0px 0px 16px 0px"
          margin="0px 0px 0px 0px"
        >
          This can be an extra paragraph overflow of the above content.
        </Text>
      </Box>
    </Section>
    <ProjectsLatestArticles project_tag="thermalstorage" />
  </>
);

export default ProjectThermalStorage;
